<template>
<!-- 과정항목 관리 팝업 -->
<div class="modal fade" id="enrollTime" tabindex="-1" role="dialog" aria-labelledby="commentLabel" aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered w-400px" role="document">
        <div class="modal-content">
            <a type="button" class="close" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">
                    <img src="../../../assets/img/close.png" alt="close" class="pointer close-btn mr-10 mt-10">
                </span>
            </a>
            <div class="modal-body">
                <div class="txt-center">
                    <h3 class="font-14 bold">교육 시간</h3>
                    <div class="mt-10 mb-10">
                        <label for="sHour">
                        <select v-model="starthh" name="sHour" id="" class="w-75px">
                            <option v-for="index in 24" :key="index" :value="plusZero((index - 1).toString())">{{plusZero((index - 1).toString())}}</option>
                        </select>
                    </label> :
                    <label for="sMinute">
                        <select v-model="startmm" name="sMinute" id="" class="w-75px">
                            <option v-for="index in 60" :key="index" :value="plusZero((index - 1).toString())">{{plusZero((index - 1).toString())}}</option>
                        </select>
                    </label> ~
                    <label for="eHour">
                        <select v-model="endhh" name="eHour" id="" class="w-75px">
                            <option v-for="index in 24" :key="index" :value="plusZero((index - 1).toString())">{{plusZero((index - 1).toString())}}</option>
                        </select>
                    </label> :
                    <label for="eMinute">
                        <select v-model="endmm" name="eMinute" id="" class="w-75px">
                            <option v-for="index in 60" :key="index" :value="plusZero((index - 1).toString())">{{plusZero((index - 1).toString())}}</option>
                        </select>
                    </label>
                    </div>
                </div>
            </div>
            <div class="modal-footer txt-center">
                <a class="admin-btn-default btn pointer mg-auto" @click="exportData()" data-dismiss="modal" aria-label="Close">입력 완료</a>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props:['gridIndex', 'rowIndex', 'parentTime'],
    data: () => ({
        starthh: '00', // 수강신청기간 시작 시간
        startmm: '00', // 수강신청기간 시작 분
        endhh: '00', // 수강신청기간 끝 시간
        endmm: '00' // 수강신청기간 끝 분
    }),
    mounted () {
        console.log('this.parentTime', this.parentTime)
         if (this.parentTime !== '') {
             console.log(123123)
             console.log('this.parentTime', this.parentTime)
            this.starthh = this.parentTime.starthh
            this.startmm = this.parentTime.startmm
            this.endhh = this.parentTime.endhh
            this.endmm = this.parentTime.endmm
        }
    },
    
    beforeDestroy () {
        console.log('초기화')
    },

    methods: {
        // 시간, 분 한자리일때 0 추가
        plusZero(time) {
            if (time.length === 1) {
                return '0' + time
            } else {
                return time
            }
        },

        exportData () {
            var subjectStartTime = this.starthh + ':' + this.startmm
            var subjectEndTime = this.endhh + ':' + this.endmm

            // var time = {
            //     starthh: this.starthh,
            //     startmm: this.startmm,
            //     endhh: this.endhh,
            //     endmm: this.endmm
            // }

            this.$emit('applyTime', subjectStartTime, subjectEndTime, this.gridIndex, this.rowIndex)
        }
    }
}
</script>
